export const FamilyPayUserStatus = {
    // 로그인 필요
    AUTH: 'AUTH',
    // 이미 동의한 사용자
    AGREED: 'AGREED',
    /** 대표 */
    ORGANIZER: 'ORGANIZER',
    /** 멤버 */
    MEMBER: 'MEMBER',
    /** 대표 19세 미만 */
    MINOR: 'MINOR',
    /** 스튜던트 맴버십 */
    STUDENT: 'STUDENT',
    /** 맴버십 미가입자 */
    UNSUBSCRIBED: 'UNSUBSCRIBED',
    /** 알수 없음 */
    UNKNOWN: 'UNKNOWN',
}

export type FamilyPayUserStatusValues = Constant<typeof FamilyPayUserStatus>

export const FamilyPayResult = {
    /** 승인 */
    ACCEPT: 'ACCEPT',
    /** 반려 */
    REFUSE: 'REFUSE',
} as const

export type FamilyPayResultType = Constant<typeof FamilyPayResult>

export const FamilyUser = {
    /** 대표 */
    PAYER: 'PAYER',
    /** 멤버 */
    MEMBER: 'MEMBER',
} as const

export type FamilyUserType = Constant<typeof FamilyUser>

/** 맴버의 결제 타입 */
export const FamilyPayMemberPaymentType = {
    /** 결제 불가 */
    UNAVAILABLE: 'UNAVAILABLE',
    /** 사전 승인결제 */
    PRE_APPROVAL_PAYMENT: 'PRE_APPROVAL_PAYMENT',
    /** 승인결제 */
    APPROVAL_PAYMENT: 'APPROVAL_PAYMENT',
} as const

export type FamilyPayMemberPaymentTypeValues = Constant<typeof FamilyPayMemberPaymentType>

/**
 * 사전승인결제 불가하여 승인결제로 전환된 사유
 * TODO(패밀리페이): 더 추가될 수 있음 확인 필요
 */
export const PreApprovalDisabledReason = {
    /** 사전승인결제 가능 금액 초과 (30만원) */
    PAYMENT_LIMIT_EXCEEDED: 'PAYMENT_LIMIT_EXCEEDED',
    /** 월간 사전승인결제 가능 금액 초과 */
    MONTHLY_LIMIT_EXCEEDED: 'MONTHLY_LIMIT_EXCEEDED',
}

export type PreApprovalDisabledReasonValues = Constant<typeof PreApprovalDisabledReason>

export const FamilyPayStatement = {
    /** 사전승인결제 */
    PRE_APPROVAL_PAYMENT: 'PRE_APPROVAL_PAYMENT',
    /** 사전승인결제 불가로 인한 승인결제 */
    APPROVAL_PAYMENT_BY_PRE_APPROVAL_PAYMENT_DISABLED: 'APPROVAL_PAYMENT_BY_PRE_APPROVAL_PAYMENT_DISABLED',
    /** 승인결제 */
    APPROVAL_PAYMENT: 'APPROVAL_PAYMENT',
    /** 비활성화 */
    DISABLE: 'DISABLE',
    /** 가입유도 */
    SIGN_UP_PROMPT: 'SIGN_UP_PROMPT',
    /** 미노출 */
    HIDE: 'HIDE',
    /** 패밀리정보 조회 실패 > 재시도 가능 */
    API_FAIL: 'API_FAIL',
} as const

export type FamilyPayStatementValues = Constant<typeof FamilyPayStatement>
